export default "__VITE_ASSET__qOaxci8E__"